import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import numberToWords from "number-to-words";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";

const ProformaInvoiceForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const bankRef = useRef({});
  const [bankClose, setBankClose] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  const [employeelist, setEmployeelist] = useState(null);
  const [employeeId, setemployeeId] = useState();

  const [salesOrderList, setsalesOrderList] = useState([]);
  const [salesOrderId, setsalesOrderId] = useState();
  const [customerId, setcustomerId] = useState();
  const [currencyId, setcurrencyId] = useState();
  const [costInWords, setCostInWords] = useState();
  const [proformalatLong, setproformalatLong] = useState({
    lat: "",
    lng: "",
  });

    useEffect(() => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          //console.log(lat, long);
          setproformalatLong({ lat, lng });
        },
        (error) => {
          console.error(error);
        }
      );
    }, []);

  const [latLongclose, setLatLongclose] = useState(false);

  const handleLatLong = () => {
    setLatLongclose(true);
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [selectedDueDate, setSelectedDueDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handledueDateChange = (e) => {
    setSelectedDueDate(e.target.value);
  };

  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState();
  const handleDeliveryDateChange = (e) => {
    setEstimatedDeliveryDate(e.target.value);
  };

  const { sendRequest: getSalesOrder } = useHttp();

  useEffect(() => {
    var url = `/api/salesOrder/?orgId=${localStorage.getItem("orgId")}`;
    if (props.update.salesOrderId) {
      url = url + `&salesOrderId=${props.update.salesOrderId}`;
    }

    getSalesOrder(
      {
        url: url,
      },
      (data) => {
        // //console.log("salesOrder", data);
        setsalesOrderList(data);
        if (props.update.salesOrderId) {
          var itemlist = data.filter(
            (item) =>
              parseInt(item.salesOrderId) == parseInt(props.update.salesOrderId)
          );

          setcustomerId(itemlist[0].customerId);
          setProductDetails(itemlist[0].salesOrderProducts);
        }
      }
    );
  }, [getSalesOrder]);

  const loadprocurmentData = (id) => {
    setsalesOrderId(id);
    frmRef.current.customer_name.value = "";
    frmRef.current.cust_org_email_id.value = "0";
    frmRef.current.contact_person_name.value = "";
    frmRef.current.email_id.value = "";
    frmRef.current.whatsapp_number.value = "";

    var itemlist = salesOrderList.filter(
      (item) => parseInt(item.salesOrderId) == parseInt(id)
    );
    //console.log("salesOrder", itemlist);

    frmRef.current.customer_name.value =
      itemlist[0].name + "(" + itemlist[0].customerCode + ")";
    frmRef.current.Currency.value = itemlist[0].currencyName;
    setcustomerId(itemlist[0].customerId);

    setProductDetails(itemlist[0].salesOrderProducts);
    frmRef.current.cust_org_email_id.value = itemlist[0].customerEmailId;
    frmRef.current.work_contact_number.value = itemlist[0].workContactNumber;
    frmRef.current.whatsapp_number.value = itemlist[0].whatsappNumber;
    frmRef.current.contact_person_name.value =
      itemlist[0].customerContactPersonName;
    frmRef.current.email_id.value = itemlist[0].customerContactPersonEmailId;
    frmRef.current.regi_address.value = itemlist[0].billingAddress;
    frmRef.current.zip_code.value = itemlist[0].billingZip;
    frmRef.current.city.value = itemlist[0].billingCity;
    frmRef.current.state.value = itemlist[0].billingState;
    frmRef.current.country.value = itemlist[0].billingCountry;
    frmRef.current.total_cost_value.value = itemlist[0].totalSalesOrderValue;
    const totalCostInWords = numberToWords.toWords(
      itemlist[0].totalSalesOrderValue
    );

    setCostInWords(totalCostInWords);

    setcurrencyId(itemlist[0].currencyId);
  };

  const { sendRequest: postProformaInvoice } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      issueDate: moment(frmRef.current.issue_date.value).format("DD/MM/YYYY"),
      dueDate: moment(frmRef.current.due_date.value).format("DD/MM/YYYY"),
      estimatedDeliveryDate: moment(
        frmRef.current.estimated_delivery_date.value
      ).format("DD/MM/YYYY"),
      customerReferenceId: salesOrderId,
      salesOrderId: salesOrderId,
      customerId: customerId,
      customerOrgEmail: frmRef.current.cust_org_email_id.value,
      contactPersonName: frmRef.current.contact_person_name.value,
      Email: frmRef.current.email_id.value,
      whatsapp: frmRef.current.whatsapp_number.value,
      contactNo: frmRef.current.work_contact_number.value,
      methodOfDispatch: frmRef.current.method_of_dispatch.value,
      typeOfShipment: frmRef.current.type_of_shipment.value,
      portOfLoading: frmRef.current.port_of_loading.value,
      portOfDischarge: frmRef.current.port_of_discharge.value,
      methodOfPayment: frmRef.current.method_of_payment.value,
      registeredAddress: frmRef.current.regi_address.value,
      city: frmRef.current.city.value,
      state: frmRef.current.state.value,
      zipCode: frmRef.current.zip_code.value,
      country: frmRef.current.country.value,
      latLong: frmRef.current.lat_long.value,
      incoTerms2020: frmRef.current.incoterms.value,
      bankDetails: bankDetails,
      productDetails: productDetails,
      consignmentTotalOrderCost: frmRef.current.total_cost_value.value,
      currencyId: currencyId,
      amtChargable: frmRef.current.amt_chargeable.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,

      warehouseId: localStorage.getItem("warehouseId"),
    };
    //console.log(data);

    if (props.update) {
      data["piId"] = props.update.piId;
    }
    postProformaInvoice(
      {
        url: "/api/profarmaInvoice/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Proforma Invoice ${props.update ? "Updated" : "Added"}`);

        props.addForm(false);
      }
    );
  };
  useEffect(() => {
    // //console.log(props.update);
    if (props.update) {
      //console.log("props.update", props.update);
      frmRef.current.issue_date.value = props.update.issueDate; //moment(props.update.issueDate).format("YYYY-MM-DD");
      frmRef.current.due_date.value = props.update.dueDate; //moment(props.update.dueDate).format("YYYY-MM-DD");
      frmRef.current.estimated_delivery_date.value =
        props.update.estimatedDeliveryDate;
      setsalesOrderId(props.update.salesOrderId);

      frmRef.current.customer_name.value = props.update.name;
      frmRef.current.cust_org_email_id.value = props.update.customerEmailId;
      frmRef.current.contact_person_name.value =
        props.update.customerContactPersonName;
      frmRef.current.email_id.value = props.update.customerContactPersonEmailId;
      frmRef.current.whatsapp_number.value = props.update.whatsappNumber;
      frmRef.current.work_contact_number.value = props.update.workContactNumber;
      frmRef.current.Currency.value = props.update.currencyCode;
      frmRef.current.type_of_shipment = props.update.typeOfShipment;
      frmRef.current.method_of_dispatch.value = props.update.methodOfDispatch;

      frmRef.current.port_of_loading.value = props.update.portOfLoading;
      frmRef.current.port_of_discharge.value = props.update.portOfDischarge;
      frmRef.current.method_of_payment.value = props.update.methodOfPayment;

      frmRef.current.regi_address.value = props.update.registeredAddress;
      frmRef.current.city.value = props.update.city;
      frmRef.current.state.value = props.update.state;
      frmRef.current.zip_code.value = props.update.zipCode;
      frmRef.current.country.value = props.update.country;
      setBankDetails(props.update.bankDetails);

      setproformalatLong(props.update.latLong);
      frmRef.current.incoterms.value = props.update.incoTerms2020;

      frmRef.current.total_cost_value.value =
        props.update.consignmentTotalOrderCost;

      frmRef.current.amt_chargeable.value = props.update.amtChargable;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,

        itemId: productRef.current.itemId.value,

        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
        itemUnitPrice: productRef.current.itemUnitPrice.value,
        rate: productRef.current.rate.value,
        currency: productRef.current.currency.value,
        subTotalAmount: productRef.current.sub_total.value,
        discount: productRef.current.discount.value,
        discountAmount: productRef.current.discountAmount.value,
        totalAmount: productRef.current.totalAmount.value,
      },
    ]);

    // //console.log(productDetails);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };
  // bank details
  const submitBankDetails = (e) => {
    e.preventDefault();
    setBankDetails((x) => [
      ...x,
      {
        srno:
          bankDetails.length > 0
            ? bankDetails[bankDetails.length - 1].srno + 1
            : 1,

        accountNumber: bankRef.current.account_number.value,
        accountHolderName: bankRef.current.acc_holder_name.value,
        ifscCode: bankRef.current.ifsc_code.value,
      },
    ]);

    // //console.log(bankDetails);
  };
  const handleDeleteBank = (index, e) => {
    setBankDetails(bankDetails.filter((v, i) => i !== index));
  };
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Proforma Invoice Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"issue_date"}>{"Issue Date "}</label>
                      <input
                        type={"date"}
                        id={"issue_date"}
                        required
                        ref={(el) => (frmRef.current["issue_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"due_date"}>{"Due Date"}</label>
                      <input
                        type={"date"}
                        id={"due_date"}
                        required
                        ref={(el) => (frmRef.current["due_date"] = el)}
                        className="form-control"
                        min={currentDate}
                        value={selectedDueDate}
                        onChange={handledueDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"estimated_delivery_date"}>
                        {"Estimated Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"estimated_delivery_date"}
                        required
                        ref={(el) =>
                          (frmRef.current["estimated_delivery_date"] = el)
                        }
                        className="form-control"
                        min={currentDate}
                        value={estimatedDeliveryDate}
                        onChange={handleDeliveryDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reference_id"}>
                        {"Buyer/Customer Reference No"}
                      </label>

                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["salesOrderId"] = el)}
                        value={salesOrderId}
                        onChange={(e) => {
                          loadprocurmentData(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {salesOrderList &&
                          salesOrderList.map((x) => (
                            <option
                              key={x.salesOrderId}
                              salesOrder-id={x.salesOrderId}
                              value={x.salesOrderId}
                            >
                              {x.salesOrderCode}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>{"Customer Name"}</label>

                      <input
                        type={"text"}
                        id={"customer_id"}
                        required
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}>{"Currency"}</label>
                      <input
                        type={"text"}
                        id={"Currency"}
                        required
                        ref={(el) => (frmRef.current["Currency"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"cust_org_email_id"}>
                        {"Customer Org. Email id"}
                      </label>
                      <input
                        type={"text"}
                        id={"cust_org_email_id"}
                        required
                        ref={(el) => (frmRef.current["cust_org_email_id"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"work_contact_number"}>
                        {"Contact Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact_number"}
                        required
                        ref={(el) =>
                          (frmRef.current["work_contact_number"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"whatsapp_number"}>
                        {"Whatsapp Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_number"}
                        required
                        ref={(el) => (frmRef.current["whatsapp_number"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"email_id"}>{"Email id"}</label>
                      <input
                        type={"text"}
                        id={"email_id"}
                        required
                        ref={(el) => (frmRef.current["email_id"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-success"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault(false);
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"type_of_shipment"}>
                        {"Type of Shipment"}
                      </label>
                      <select
                        id="type_of_shipment"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["type_of_shipment"] = el)}
                      >
                        <option value="">Select</option>
                        <option value="Full Container Load(FCL)">
                          Full Contain er Load(FCL)
                        </option>
                        <option value="Less than Container Load(LCL)">
                          Less than Container Load(LCL)
                        </option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"method_of_payment"}>
                        {"Terms/Method of payment"}
                      </label>
                      <input
                        type={"text"}
                        id={"method_of_payment"}
                        required
                        ref={(el) => (frmRef.current["method_of_payment"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"port_of_loading"}>
                        {"Port of Loading"}
                      </label>
                      <input
                        type={"text"}
                        id={"port_of_loading"}
                        required
                        ref={(el) => (frmRef.current["port_of_loading"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"method_of_dispatch"}>
                        {"Method  of Dispatch"}
                      </label>
                      <select
                        id="method_of_dispatch"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["method_of_dispatch"] = el)
                        }
                      >
                        <option value="">Select</option>
                        <option value="Land">Land</option>
                        <option value="Sea">Sea</option>
                        <option value="Air">Air</option>
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"incoterms"}>{"Incoterms® 2020"}</label>
                      <input
                        type={"text"}
                        id={"incoterms"}
                        required
                        ref={(el) => (frmRef.current["incoterms"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"port_of_discharge"}>
                        {"Port of Discharge"}
                      </label>
                      <input
                        type={"text"}
                        id={"port_of_discharge"}
                        required
                        ref={(el) => (frmRef.current["port_of_discharge"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"regi_address"}>
                        {"Registered Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"regi_address"}
                        required
                        ref={(el) => (frmRef.current["regi_address"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"zip_code"}>
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"zip_code"}
                        required
                        ref={(el) => (frmRef.current["zip_code"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"city"}
                        required
                        ref={(el) => (frmRef.current["city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"state"}>{"State/Province/Region"}</label>
                      <input
                        type={"text"}
                        id={"state"}
                        required
                        ref={(el) => (frmRef.current["state"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"country"}> {"Country"}</label>
                      <input
                        type={"text"}
                        id={"country"}
                        required
                        ref={(el) => (frmRef.current["country"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"lat_long"}>{"Lat/Long"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        onClick={(e) => {
                          handleLatLong(e);
                        }}
                        ref={(el) => (frmRef.current["lat_long"] = el)}
                        className="btn btn-sm btn-info"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"total_cost_value"}>
                        {"Total Order Cost "}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost_value"}
                        required
                        readOnly
                        ref={(el) => (frmRef.current["total_cost_value"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        readOnly
                        value={costInWords}
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bank_details"}> {"Bank Details"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          bankDetails &&
                            setBankDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setBankClose(true);
                        }}
                        type="button"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <h4 className="card-title">Product Details</h4>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setClose(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Sr. No</th>

                <th>Item Description</th>
                <th>Item SubType</th>

                <th>Item Unit Price</th>
                <th>Rate</th>
                <th>Item Quantity</th>
                <th>Unit</th>
                <th>Sub Total </th>
                <th>Discount</th>
                <th>Discount Amount</th>
                <th>Total Amount</th>
              </tr>
            </thead>

            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.lineSrNo}</td>

                      <td>{itm.productName}</td>
                      <td>{itm.productSubTypeName}</td>

                      <td>{itm.itemUnitPrice}</td>
                      <td>{itm.rate}</td>
                      <td>{itm.salesOrderQuantityBalance}</td>
                      <td>{itm.unitAbbreviation}</td>
                      <td>{itm.subTotalAmount}</td>
                      <td>{itm.discount}</td>
                      <td>{itm.discountAmount}</td>
                      <td>{itm.totalLineAmount}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Modal>
      )}
      {/* bank modal start */}
      {bankClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title"> Bank Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setBankClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"account_number"}>Account Number</label>

                <input
                  type={"input"}
                  id={"account_number"}
                  required
                  ref={(el) => (bankRef.current["account_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"acc_holder_name"}>Acc Holder Name</label>

                <input
                  type={"input"}
                  id={"acc_holder_name"}
                  required
                  ref={(el) => (bankRef.current["acc_holder_name"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"ifsc_code"}>IFSC Code</label>

                <input
                  type={"input"}
                  id={"ifsc_code"}
                  required
                  ref={(el) => (bankRef.current["ifsc_code"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <br />
              <div className="form-group">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={submitBankDetails}
                  type="button"
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <hr />
          <div className="flexRow">
            <table className="table table-bordered text-center table-sm">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {bankDetails &&
                  bankDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>

                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => handleDeleteBank(i, e)}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="btn btn-sm btn-primary"
              onClick={() => {
                bankDetails && bankDetails.map((x) => (x["isSave"] = true));
                setBankClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* bank modal end */}
      {latLongclose && (
        <Modal isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={proformalatLong.lat}
            lng={proformalatLong.lng}
            set={setproformalatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}
    </>
  );
};

export default ProformaInvoiceForm;
